import { createMuiTheme } from '@material-ui/core/styles';
import { PaletteColor, PaletteColorOptions } from '@material-ui/core/styles/createPalette';
import { typography, TypographyStylesMap } from './typography';
import { paletteOpts } from './color';

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    typographyStyles: TypographyStylesMap
  }
  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    typographyStyles: TypographyStylesMap
  }
}

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    accent: PaletteColor;
    border: PaletteColor;
    placeholder: PaletteColor;
  }
  interface PaletteOptions {
    accent: PaletteColorOptions;
    border: PaletteColorOptions;
    placeholder: PaletteColorOptions;
  }
}

export const theme = createMuiTheme({
  palette: paletteOpts,

  typographyStyles: typography,

  typography: {
    fontFamily: 'Prompt, sans-serif',
    fontSize: 14,
    h1: {
      fontSize: 36,
      margin: 0,
      padding: 0,
      fontWeight: 500
    },
    h2: {
      fontSize: 24,
      margin: 0,
      padding: 0,
      fontWeight: 500
    },
    h3: {
      fontSize: 20,
      margin: 0,
      padding: 0,
      fontWeight: 500
    },
    h4: {
      fontSize: 18,
      margin: 0,
      padding: 0,
      fontWeight: 500
    },
    h5: {
      fontSize: 16,
      margin: 0,
      padding: 0,
      fontWeight: 500
    },
    h6: {
      fontSize: 14,
      margin: 0,
      padding: 0,
      fontWeight: 500
    },
    subtitle1: {
      fontSize: 16,
      margin: 0,
      padding: 0,
      fontWeight: 300
    },
    subtitle2: {
      fontSize: 16,
      margin: 0,
      padding: 0,
      fontWeight: 500
    },
    body1: {
      fontSize: 16,
      margin: 0,
      padding: 0,
      fontWeight: 300
    },
    body2: {
      fontSize: 16,
      margin: 0,
      padding: 0,
      fontWeight: 500
    },
    button: {
      fontSize: 18,
      fontWeight: 500
    },
    caption: {
      fontSize: 12,
      fontWeight: 400
    }
  },

  breakpoints: {
    values: {
      xl: 1440,
      lg: 1280,
      md: 960,
      sm: 600,
      xs: 0
    }
  }
});
